import { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { cutHashFromURL } from 'utils/getURLData'
import { UnavailableReasons } from 'constants/webinar-data'
import { popupName } from 'constants/auth/auth-data'
import { A_LOG_REG_HASH, originRegWebinars } from 'utils/analytics/other/registration/registration'

import styles from '../commentaries.module.scss'

interface IUnavailableCommentBottom {
  reason: keyof typeof UnavailableReasons
}

const UnavailableCommentBottom: FC<IUnavailableCommentBottom> = ({
  reason,
}: IUnavailableCommentBottom) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const btnHandler = () => {
    sessionStorage.setItem(A_LOG_REG_HASH, originRegWebinars.COMMENT)
  }

  return (
    <div className={clsx(styles.commentInputBlock, styles.unAuthInputBlock)}>
      {reason === UnavailableReasons.unauth && (
        <p className={styles.noAuthTxt} onClick={btnHandler}>
          Чтобы оставить комментарий, пожалуйста,{' '}
          <Link className={styles.link} href={`${path}#${popupName.registration}`} prefetch={false}>
            войдите
          </Link>{' '}
          на портал
        </p>
      )}
      {reason === UnavailableReasons.unpaid && (
        <p>Оставить комментарий могут только пользователи, купившие доступ к этому семинару.</p>
      )}
    </div>
  )
}

export default UnavailableCommentBottom
